import { render, staticRenderFns } from "./table-proposal.vue?vue&type=template&id=27bc890c&scoped=true&"
import script from "./table-proposal.vue?vue&type=script&lang=js&"
export * from "./table-proposal.vue?vue&type=script&lang=js&"
import style0 from "./table-proposal.vue?vue&type=style&index=0&id=27bc890c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc890c",
  null
  
)

export default component.exports